import { useEffect, useState } from "react";
import { LoginScreen } from "./screens/Login";
import { ClassroomScreen } from "./screens/Classroom";
import { getUser, type SignedInUser } from "./lib/api";

export function App(): JSX.Element {
  const [user, setUser] = useState<SignedInUser | null>(getUser());

  // Re-read session on storage events (multi-tab logout).
  useEffect(() => {
    const handler = (): void => setUser(getUser());
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  return (
    <div className="app">
      <header className="topbar">
        <a className="brand" href="/">
          <span className="word-locker">Locker</span>
          <span className="word-edu">EDU</span>
          <span className="brand-sub">dashboard</span>
        </a>
        <nav className="topbar-nav">
          {user ? (
            <button
              className="env-pill env-pill-action"
              onClick={() => {
                localStorage.removeItem("lockeredu.jwt");
                localStorage.removeItem("lockeredu.user");
                setUser(null);
              }}
            >
              Sign out · {user.displayName}
            </button>
          ) : (
            <span className="env-pill">Day 2 · stealth</span>
          )}
        </nav>
      </header>

      <main className="main-single">
        {user ? <ClassroomScreen user={user} /> : <LoginScreen onSignedIn={setUser} />}
      </main>

      <footer className="foot">
        <span>© 2026 LockerEDU · stealth pilot</span>
        <span>app.lockeredu.com</span>
      </footer>
    </div>
  );
}
